<p-dialog
  header="Deletion Remarks"
  [(visible)]="deleteRecord"
  modal="modal"
  width="500"
>
  <ara-textarea
    [sourceText]="observationData.DeletionReason"
    [maxLength]="1000"
    disabled="false"
    (output)="getRemarks($event, 'DeletionReason', 0)"
  ></ara-textarea>
  <div *ngIf="showDeletionmsg">
    <span class="error-msg-colour">{{
      "ACTIONTRACKER.PLEASE_ENTER_DELETION_REMARKS." | translate
    }}</span>
  </div>
  <p-footer>
    <button
      type="button"
      pButton
      (click)="deleteAction(deleteActionId)"
      label="Submit"
      class="active-btn orange-btn button-submit"
    ></button>
    <button
      type="button"
      pButton
      (click)="onCancelClick()"
      label="Cancel"
      class="active-btn orange-btn button-cancel"
    ></button>
  </p-footer>
</p-dialog>
<p-dialog
  header="Cancellaction Remarks"
  [(visible)]="cancelRecord"
  modal="modal"
  width="500"
>
  <ara-textarea
    [sourceText]="observationData.CancellationReason"
    [maxLength]="1000"
    disabled="false"
    (output)="getRemarks($event, 'CancellationReason', 0)"
  ></ara-textarea>
  <div *ngIf="showCancellationmsg">
    <span class="error-msg-colour">{{
      "ACTIONTRACKER.PLEASE_ENTER_CANCELLATION_REMARKS." | translate
    }}</span>
  </div>
  <p-footer>
    <button
      type="button"
      pButton
      (click)="cancelAction(cancelActionId)"
      label="Submit"
      class="active-btn orange-btn button-submit"
    ></button>
    <button
      type="button"
      pButton
      (click)="onCancel()"
      label="Cancel"
      class="active-btn orange-btn button-cancel"
    ></button>
  </p-footer>
</p-dialog>
<!-- <ara-side-nav class="inside-topnav" [routesFlag]="routesFlag" [reportRoutes]="reportRoutes"
  *ngIf="!isBackOfficeViewDetailsPage"></ara-side-nav> -->
<div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mobile-view">
    <ol class="breadcrumb bc-3">
      <li>
        <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Observation / Interventions</a>
      </li>
    </ol>
    <div class="inner-wrapper">
      <div class="sub-wrapper">
        <h3 class="page-title obs-card-title" style="text-align: center">
          <span class="page-sub-title">
            <ng-container
              *ngIf="observationId > 0 && observationData?.Status !== 'Draft'"
              >Observation
              {{ observationId }}
            </ng-container>
            <ng-container
              *ngIf="observationId === 0 || observationData?.Status === 'Draft'"
              >New Observation
            </ng-container>
          </span>
          <button
            *ngIf="observationId > 0"
            (click)="isNext ? onNextClick() : $event.preventDefault()"
            [ngClass]="isNext ? 'cursor-pointer' : 'disabled'"
            class="pull-right btn btn-primary primary-btn"
          >
            <i class="fa fa-angle-right"></i>
          </button>
          <button
            *ngIf="observationId > 0"
            (click)="isPrevious ? onPreviousClick() : $event.preventDefault()"
            [ngClass]="isPrevious ? 'cursor-pointer' : 'disabled'"
            class="pull-right btn btn-primary primary-btn"
          >
            <i class="fa fa-angle-left"></i>
          </button>
        </h3>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
          <div class="section-wrapper">
            <span class="mandatory-info pull-right">
              Fields marked with
              <span class="mandatory">*</span> are mandatory
            </span>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "OBSERVATION.UNIT" | translate }}
              <i
                class="fa fa-info-circle"
                pTooltip="Unit are enabled for interaction based on permission of User"
              ></i
              >&nbsp; <span class="name-mandatory">*</span></span
            >
            <p-tree
              [value]="unitTree"
              selectionMode="single"
              (onNodeSelect)="nodeSelected($event)"
              [(selection)]="selectedUnit"
              [styleClass]="disableObservation ? 'disabled' : 'cursor-pointer'"
            ></p-tree>
            <span class="error-msg-colour" *ngIf="unitError"
              >Please select unit</span
            >
          </div>
          <div class="sub-section-wrapper" [hidden]="isUnitEmployee">
            <span class="section-sub-title"
              >Contract Number <span class="mandatory">*</span></span
            >
            <!-- <input type="text" maxlength="50" value="" class="form-control margin-top-10" id="name"
              [(ngModel)]="ContractNumber" placeholder="Contract Number"
              [disabled]="true"> -->
            <p-dropdown
              [options]="contracts"
              placeholder="Select"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedContract"
              (onChange)="checkHolder($event)"
            >
            </p-dropdown>
            <span class="error-msg-colour" *ngIf="showContractValidation"
              >Please select Contract Number
            </span>
            <span class="error-msg-colour" *ngIf="!isHasContractDetails"
              >Contract Holder is not available for this contract. Please
              contact admin to update these details.
            </span>
          </div>
          <div class="sub-section-wrapper" *ngIf="isObservationForDisplay">
            <span class="section-sub-title"
              >{{ "OBSERVATION.OBSERVATION_FOR" | translate }}
              <span class="name-mandatory">*</span></span
            ><br />
            <label
              class="radio-inline no-margin-top margin-bottom-10"
              *ngIf="!isBackOfficeViewDetailsPage"
            >
              <input
                type="radio"
                value="self"
                name="observation"
                [(ngModel)]="observationFor"
                (click)="setObservationForEdit('self')"
                [checked]="selfObservationDataFlag"
                [disabled]="disableObservation"
              />{{ "OBSERVATION.SELF" | translate }}
            </label>
            <label
              class="radio-inline no-margin-top margin-bottom-10"
              *ngIf="navigator.onLine"
            >
              <input
                type="radio"
                value="onbehalfemp"
                name="observation"
                [(ngModel)]="observationFor"
                (click)="setObservationForEdit('onbehalfemp')"
                [checked]="onBehalfEmpObservationDataFlag"
                [disabled]="disableObservation"
              />{{ "OBSERVATION.ON_BEHALF_OF_EMPLOYEE" | translate }}
            </label>
            <label
              class="radio-inline no-margin-top margin-bottom-10"
              *ngIf="!isBackOfficeViewDetailsPage && navigator.onLine"
            >
              <input
                type="radio"
                value="onbehalfcontractor"
                name="observation"
                (click)="setObservationForEdit('onbehalfcontractor')"
                [(ngModel)]="observationFor"
                [checked]=""
                [disabled]="disableObservation"
              />{{ "OBSERVATION.ON_BEHALF_OF_CONTRACTOR" | translate }}
            </label>
          </div>
          <div
            class="sub-section-wrapper"
            *ngIf="
              onBehalfEmpObservationDataFlag &&
              (independentPermissions.OBS_View_Observer ||
                permissions.OBS_Admin ||
                permissions.OBS_Admin_Unit ||
                permissions.OBS_Own ||
                ((permissions.OBS_Add || permissions.OBS_Add_Unit) &&
                  observationId === 0))
            "
          >
            <span class="section-sub-title"
              >{{ "OBSERVATION.EMPLOYEE_NAME" | translate }}
              <span class="mandatory">*</span></span
            >
            <p-autoComplete
              [(ngModel)]="selectedUserEmp"
              [suggestions]="userResults"
              appendTo="body"
              (completeMethod)="getUsersOnSearch($event)"
              (onSelect)="selectUser($event)"
              placeholder="Employee Name"
              field="FullName"
              [minLength]="1"
              [style]="{ width: '100%' }"
              [inputStyle]="{ width: '100%' }"
              [forceSelection]="true"
              [disabled]="disableObservation"
            >
              <ng-template let-employee pTemplate="item">
                <span [title]="employee.Email">{{ employee.FullName }}</span>
              </ng-template>
            </p-autoComplete>
            <div
              *ngIf="
                isEmployeeNameErrorMsg &&
                (selectedUserEmp == null || selectedUserEmp?.UserId === 0)
              "
            >
              <span style="color: red">Kindly select employee name.</span>
            </div>
          </div>
          <div
            class="sub-section-wrapper"
            *ngIf="
              showForContractor &&
              (independentPermissions.OBS_View_Observer ||
                permissions.OBS_Admin ||
                permissions.OBS_Admin_Unit ||
                permissions.OBS_Own ||
                ((permissions.OBS_Add || permissions.OBS_Add_Unit) &&
                  observationId === 0))
            "
          >
            <span class="section-sub-title"
              >{{ "OBSERVATION.CONTRACTOR_NAME" | translate }}
              <span class="mandatory">*</span></span
            >
            <p-autoComplete
              [(ngModel)]="selectedUserContractor"
              [suggestions]="userResults"
              appendTo="body"
              (onSelect)="selectUser($event)"
              (completeMethod)="getUsersOnSearch($event)"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Contractor Name"
              [minLength]="1"
              [style]="{ width: '100%' }"
              [inputStyle]="{ width: '100%' }"
              field="FullName"
              [forceSelection]="true"
              [disabled]="disableObservation"
            >
              <ng-template let-contractor pTemplate="item">
                <div>
                  <span [title]="contractor.Email">{{
                    contractor.FullName
                  }}</span>
                </div>
              </ng-template>
            </p-autoComplete>
            <div
              *ngIf="
                isContractorNameErrorMsg &&
                (selectedUserContractor == null ||
                  selectedUserContractor?.UserId === 0)
              "
            >
              <span class="error-msg-colour"
                >Kindly select Contractor name.</span
              >
            </div>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "OBSERVATION.LOCATION" | translate }}
              <span class="mandatory">*</span></span
            >
            <p-dropdown
              [options]="locations"
              placeholder="Select"
              [(ngModel)]="selectedLocation"
              [style]="{ width: '100%' }"
              (onChange)="saveLocation()"
              [disabled]="
                disableObservation ||
                (observationId > 0 &&
                  observationData.Status !== 'Draft' &&
                  isInactiveLocation &&
                  !independentPermissions.APP_Admin &&
                  !independentPermissions.HSE_Admin &&
                  !independentPermissions.SUPER_Admin)
              "
            ></p-dropdown>
            <div *ngIf="isLocationErrorMsg && !observationData.LocationId">
              <span class="error-msg-colour">Kindly select location.</span>
            </div>
            <div *ngIf="isInactiveLocation">
              <span class="error-msg-colour">This Location is In Active.</span>
            </div>
          </div>
          <ara-exact-location
            [Location]="observationData.ExactLocation"
            [Disabled]="disableObservation"
            (Output)="setLocation($event)"
          ></ara-exact-location>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "OBSERVATION.DATE_&_TIME" | translate }}
              <span class="mandatory">*</span></span
            >
            <div class="dt-time-wrapper">
              <p-calendar
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [maxDate]="dateTime"
                [showTime]="true"
                placeholder=""
                [(ngModel)]="observationData.ObservationDate"
                class="custom-datepicker"
                readonlyInput="true"
                required
                #timeOfUse="ngModel"
                [disabled]="disableObservation"
                monthNavigator="true"
                yearNavigator="true"
                yearRange="1950:2100"
              ></p-calendar>
              <div
                *ngIf="
                  isObservationDateErrorMsg && !observationData.ObservationDate
                "
              >
                <span class="error-msg-colour"
                  >Kindly enter date and time of the observation.</span
                >
              </div>
            </div>
          </div>
          <div class="sub-section-wrapper obs-type-groups-wrapper">
            <span
              class="section-sub-title"
              pTooltip="Please select one Observation type from each group"
            >
              {{ "OBSERVATION.TYPE_OF_OBSERVATION" | translate }}
              <span class="mandatory">*</span></span
            >
            <div class="clearfix"></div>

            <div class="form-group">
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 no-padding">
                <div class="obs-type-groups">
                  <div>
                    <div class="radio-inline">
                      <label>
                        <input
                          type="radio"
                          name="safeGroup"
                          value="5"
                          [disabled]="disableObservation"
                          [(ngModel)]="safeGroup"
                        />
                        {{ "OBSERVATION.UNSAFE" | translate }}
                      </label>
                    </div>
                  </div>
                  <div class="margin-top-10">
                    <div class="radio-inline">
                      <label>
                        <input
                          type="radio"
                          name="safeGroup"
                          value="2"
                          [disabled]="disableObservation"
                          [(ngModel)]="safeGroup"
                        />
                        {{ "OBSERVATION.SAFE" | translate }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding">
                <div class="obs-type-groups">
                  <div>
                    <div class="radio-inline">
                      <label>
                        <input
                          type="radio"
                          name="actBehaviourGroup"
                          value="6"
                          [disabled]="disableObservation"
                          [(ngModel)]="actBehaviourGroup"
                        />
                        {{ "OBSERVATION.CONDITION" | translate }}
                      </label>
                    </div>
                  </div>
                  <div class="margin-top-10">
                    <div class="radio-inline">
                      <label>
                        <input
                          type="radio"
                          name="actBehaviourGroup"
                          value="3"
                          [disabled]="disableObservation"
                          [(ngModel)]="actBehaviourGroup"
                        />
                        {{ "OBSERVATION.ACT" | translate }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5 no-padding">
                <div class="obs-type-groups">
                  <div class="radio-inline">
                    <label>
                      <input
                        type="radio"
                        name="observationGroup"
                        value="4"
                        [disabled]="disableObservation"
                        [(ngModel)]="observationGroup"
                      />
                      {{ "OBSERVATION.OBSERVATION" | translate }}
                    </label>
                  </div>
                  <div class="margin-top-10">
                    <div class="radio-inline">
                      <label>
                        <input
                          type="radio"
                          name="observationGroup"
                          value="1"
                          [disabled]="disableObservation"
                          [(ngModel)]="observationGroup"
                        />
                        {{ "OBSERVATION.CONVERSATION" | translate }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="isObservationTypeErrorMsg && !observationCheck">
              <span class="error-msg-colour"
                >Kindly select at least one observation type.</span
              >
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ "OBSERVATION.WHAT_DID_YOU_OBSERVE" | translate }}
              <span class="mandatory">*</span>
            </span>
            <ara-textarea
              [sourceText]="observationData.WhatObserved"
              rows="4"
              cols="30"
              [maxLength]="1000"
              [disabled]="disableObservation"
              (output)="getRemarks($event, 'WhatObserved', 0)"
            ></ara-textarea>
            <div *ngIf="isWhatObserveErrorMsg && !observationData.WhatObserved">
              <span class="error-msg-colour"
                >Kindly Enter Details of what did you observe or what
                changed.</span
              >
            </div>
            <div *ngIf="observationData.WhatObserved.length > 1000">
              <span class="error-msg-colour"
                >You can enter 1000 characters only</span
              >
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">{{
                "OBSERVATION.UPLOAD_DOCUMENTS" | translate
              }}</span>
              <ara-file-upload
                [accept]="accept"
                [multiple]="multiple"
                (onInputFilesUpdatedData)="
                  onInputFilesUpdated($event, 'WhatObserved', 0)
                "
                [(inputFiles)]="observationData.WhatObservedFiles"
                [disabled]="disableObservation"
              >
              </ara-file-upload>
              <ara-files-previewer
                [files]="WhatObservedFiles"
              ></ara-files-previewer>
            </div>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ "OBSERVATION.WHAT_DID_YOU_DO_ABOUT_IT?" | translate }}
              <span class="mandatory">*</span>
            </span>
            <ara-textarea
              rows="4"
              cols="30"
              [sourceText]="observationData.WhatYouDid"
              [maxLength]="1000"
              [disabled]="disableObservation"
              (output)="getRemarks($event, 'WhatYouDid', 0)"
            ></ara-textarea>
            <div *ngIf="isWhatYouDidErrorMsg && !observationData.WhatYouDid">
              <span class="error-msg-colour"
                >Kindly Enter Details of what did you do about it.</span
              >
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">{{
                "OBSERVATION.DID_YOU_STOP_THE_JOB?" | translate
              }}</span>
              <label class="radio-inline">
                <input
                  type="radio"
                  [(ngModel)]="IsJobStopped"
                  value="true"
                  name="whatdid"
                  [disabled]="disableObservation"
                />{{ "OBSERVATION.YES" | translate }}
              </label>
              <label class="radio-inline">
                <input
                  type="radio"
                  [(ngModel)]="IsJobStopped"
                  value="false"
                  name="whatdid"
                  [disabled]="disableObservation"
                />{{ "OBSERVATION.NO" | translate }}
              </label>

              <div
                *ngIf="isJobStoppedErrorMsg && !observationData.IsJobStopped"
              >
                <span class="error-msg-colour"
                  >Kindly specify If you stopped the job.</span
                >
              </div>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">{{
                "OBSERVATION.UPLOAD_DOCUMENTS" | translate
              }}</span>
              <ara-file-upload
                [accept]="accept"
                [multiple]="multiple"
                [(inputFiles)]="observationData.WhatYouDidFiles"
                (onInputFilesUpdatedData)="
                  onInputFilesUpdated($event, 'WhatYouDid', 0)
                "
                [disabled]="disableObservation"
              >
              </ara-file-upload>
              <ara-files-previewer
                [files]="WhatYouDidFiles"
              ></ara-files-previewer>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ "OBSERVATION.WHAT_IS_THE_MAIN_REASON" | translate }}
            </span>
            <ara-textarea
              rows="4"
              cols="30"
              [sourceText]="observationData.WhatIsTheReason"
              [maxLength]="1000"
              [disabled]="disableObservation"
              (output)="getRemarks($event, 'WhatIsTheReason', 0)"
            ></ara-textarea>
            <div></div>
            <div class="clearfix"></div>
          </div>

          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{
                "OBSERVATION.WHAT_CAN_WE_DO_TO_PREVENT_THIS_SITUATION?"
                  | translate
              }}
            </span>
            <ara-textarea
              rows="4"
              cols="30"
              [sourceText]="observationData.WhatWeCouldDo"
              [maxLength]="1000"
              [disabled]="disableObservation"
              (output)="getRemarks($event, 'WhatWeCouldDo', 0)"
            ></ara-textarea>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">{{
                "OBSERVATION.UPLOAD_DOCUMENTS" | translate
              }}</span>
              <ara-file-upload
                [accept]="accept"
                [multiple]="multiple"
                [disabled]="disableObservation"
                (onInputFilesUpdatedData)="
                  onInputFilesUpdated($event, 'WhatWeCouldDo', 0)
                "
                [(inputFiles)]="observationData.WhatWeCouldDoFiles"
              >
              </ara-file-upload>
              <ara-files-previewer
                [files]="WhatWeCouldDoFiles"
              ></ara-files-previewer>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper hazards-wrapper" *ngIf="false">
            <span class="section-sub-title">
              {{ "OBSERVATION.HAZARDS_IDENTIFIED" | translate }}
              <span class="mandatory">*</span>
              <span class="info">(Please tick)</span>
            </span>
            <div class="clearfix"></div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding">
              <div *ngFor="let hazard of circlehazards; let i = index">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-3 no-padding">
                  <div class="checkbox checkbox-table">
                    <label>
                      <input
                        type="checkbox"
                        value="hazard"
                        (change)="SubmitCheckedHazardValue(hazard, $event)"
                        [checked]="hazard.Checked"
                        [disabled]="
                          selectedtriangleHazardTypes.length ||
                          disableObservation
                        "
                      />
                      <img
                        src="{{ hazard.FileURL }}"
                        class="hazard-img"
                        pTooltip="{{ hazard.HazardName }}"
                        tooltipPosition="top"
                      />
                    </label>
                  </div>
                </div>
                <div class="clearfix" *ngIf="(i + 1) % 4 == 0"></div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding">
              <div *ngFor="let hazard of trianglehazards; let i = index">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-3 no-padding">
                  <div class="checkbox checkbox-table">
                    <label>
                      <input
                        type="checkbox"
                        value="hazard"
                        (change)="SubmitCheckedHazardValue(hazard, $event)"
                        [checked]="hazard.Checked"
                        [disabled]="
                          selectedHazardTypes.length || disableObservation
                        "
                      />
                      <img
                        src="{{ hazard.FileURL }}"
                        class="hazard-img"
                        pTooltip="{{ hazard.HazardName }}"
                        tooltipPosition="top"
                      />
                    </label>
                  </div>
                </div>
                <div class="clearfix" *ngIf="(i + 1) % 4 == 0"></div>
              </div>
            </div>

            <div class="clearboth">
              <div
                class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding margin-top-10"
              >
                <label>{{ "OBSERVATION.NOT_LISTED" | translate }} :</label>
                <input
                  type="text"
                  maxlength="100"
                  [(ngModel)]="observationData.NotListed"
                  class="form-control not-listed-input"
                  id="usr"
                  [disabled]="disableObservation"
                />
                <div
                  *ngIf="
                    isHazardErrorMsg &&
                    !hazardCheck &&
                    !observationData.NotListed
                  "
                >
                  <span class="error-msg-colour">
                    Kindly select at least one hazard or enter hazard name in
                    not listed field.
                  </span>
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
          <!-- <ara-category *ngIf="
              permissions.OBS_CAT_Add ||
              permissions.OBS_CAT_Add_Unit ||
              permissions.OBS_Admin ||
              permissions.OBS_Admin_Unit
            "
             [moduleId]="moduleId" [sourceId]="observationId" [isActive]="isActive" [disabled]="disableObservation"
            (categoryCheckedValueEmittedData)="
              categoryCheckedEmittedValue($event)
            ">
          </ara-category> -->
          <ara-category
            [moduleId]="moduleId"
            [sourceId]="observationId"
            [isActive]="isActive"
            [disabled]="disableObservation"
            (categoryCheckedValueEmittedData)="
              categoryCheckedEmittedValue($event)
            "
          >
          </ara-category>
          <div
            class="section-wrapper"
            *ngIf="
              ((permissions.OBS_Admin || permissions.OBS_Admin_Unit) &&
                observationData?.Status === 'New') ||
              observationData?.Status === 'Acknowledged' ||
              permissions.OBS_Admin ||
              permissions.OBS_Admin_Unit
            "
          >
            <span class="section-title">
              {{ "OBSERVATION.HSE_ADVISOR_FEEDBACK" | translate }}
            </span>
            <div class="clearfix"></div>
            <ara-textarea
              rows="4"
              cols="30"
              [maxLength]="1000"
              [sourceText]="observationData.Feedback"
              [disabled]="observationData?.Status === 'Acknowledged'"
              (output)="getRemarks($event, 'Feedback', 0)"
            ></ara-textarea>
            <span *ngIf="isFeedbackErrorMsg && !observationData.Feedback">
              <span class="error-msg-colour">Kindly Enter the feedback</span>
            </span>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">{{
                "OBSERVATION.UPLOAD_DOCUMENTS" | translate
              }}</span>
              <ara-file-upload
                [accept]="accept"
                [multiple]="multiple"
                [(inputFiles)]="observationData.HSEAdvisorFeedBackFiles"
                [disabled]="observationData?.Status === 'Acknowledged'"
                (onInputFilesUpdatedData)="
                  onInputFilesUpdated($event, 'HSEAdvisorFeedBack', 0)
                "
              >
              </ara-file-upload>
              <ara-files-previewer
                [files]="HseAdvisorFiles"
              ></ara-files-previewer>
            </div>
            <div class="clearfix"></div>
          </div>
          <ara-record-actions
            [SourceId]="observationId"
            ModuleName="Observation"
            *ngIf="observationId > 0"
            [ShowCancel]="
              (observationData.Status === 'New' ||
                observationData.Status === 'Acknowledged') &&
              (permissions.OBS_Admin ||
                permissions.OBS_Admin_Unit ||
                permissions.OBS_Own) &&
              observationData.Status !== 'Cancelled'
            "
            [ShowDelete]="
              independentPermissions.SUPER_Admin &&
              observationData?.Status !== 'Cancelled' &&
              observationData?.Status !== 'Deleted'
            "
            [ShowRestate]="
              observationData.Status === 'Cancelled' &&
              (permissions.OBS_Admin ||
                permissions.OBS_Admin_Unit ||
                permissions.OBS_Own)
            "
            [Status]="observationData?.Status"
            (output)="getOutput($event)"
          ></ara-record-actions>
          <!-- <div class="section-wrapper"
            *ngIf="observationData.Status === 'New' && (permissions.OBS_Admin || permissions.OBS_Admin_Unit || permissions.OBS_Own) || observationData.Status === 'Cancelled'">
            <span class="section-title">{{ 'OBSERVATION.CANCEL_OBSERVATION' | translate }}</span>
            <div class="clearfix"></div>
            <div *ngIf="observationData.Status === 'Cancelled'">
              <label>Cancellation Date</label><br>
              {{observationData.CancellationDate | dateTimeFormat}}
            </div>
            <label>{{ 'OBSERVATION.CANCELLATION_REMARKS' | translate }}</label>
            <ara-textarea [sourceText]="reason" [maxLength]="1000" [disabled]="disableObservation"
              (output)="getRemarks($event,'CancellationReason',0)"></ara-textarea>
            <div class="clearfix"></div>
            <div *ngIf="(!reason && validateCancellationRemarks)">
              <span class="error-msg-colour">Kindly enter remarks.</span>
            </div>
            <footer>
              <a role="button" *ngIf="observationData.Status === 'New'" class="btn btn-primary primary-btn"
                (click)="cancelObservationRequest()">
                <i class="fa fa-times-circle-o" aria-hidden="true"></i>Cancel
              </a>
            </footer>
          </div> -->
          <!-- <div class="section-wrapper"
            *ngIf="observationData.Status === 'Cancelled' && (permissions.OBS_Admin || permissions.OBS_Admin_Unit || permissions.OBS_Own)">
            <span class="section-title">{{ 'OBSERVATION.RESTATE_OBSERVATION' | translate }}</span>
            <div class="clearfix"></div>
            <label>Restate Reason</label>
            <ara-textarea [sourceText]="restatereason" [maxLength]="1000" [disabled]="disableObservation"
              (output)="getRemarks($event,'RestateReason',0)"></ara-textarea>
            <div class="clearfix"></div>
            <div *ngIf="(!restatereason && validateCancellationRemarks)">
              <span class="error-msg-colour">Kindly enter restate Reason.</span>
            </div>
            <footer>
              <a role="button" *ngIf="observationData.Status === 'Cancelled'" class="btn btn-primary primary-btn"
                (click)="ReStateObservationrequest()">
                <i class="fa fa-times-circle-o" aria-hidden="true"></i>Restate
              </a>
            </footer>
          </div> -->
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div
            class="section-wrapper add-action-wrapper"
            *ngIf="
              permissions.OBS_Admin ||
              permissions.OBS_Admin_Unit ||
              (observationId > 0 &&
                actionList.length >= 1 &&
                actionList[0].ActionId > 0)
            "
          >
            <span class="section-title">{{
              "OBSERVATION.ADD_ACTION_YOU_WANT_TO_TAKE" | translate
            }}</span>
            <div class="table-responsive margin-bottom-20 add-action-table">
              <table
                style="align-content: center"
                class="table table-bordered table-striped table-condensed tableheader table-red"
              >
                <tbody *ngFor="let action of actionList; let i = index">
                  <tr
                    *ngIf="
                      permissions.OBS_Admin ||
                      permissions.OBS_Admin_Unit ||
                      (!permissions.OBS_Admin &&
                        !permissions.OBS_Admin_Unit &&
                        !independentPermissions.SUPER_Admin &&
                        action.Status !== 'Deleted')
                    "
                  >
                    <th colspan="7" class="action-details-th">
                      <a
                        class="action-details"
                        [ngClass]="
                          action.ActionId > 0 ? 'cursor-pointer' : 'disabled'
                        "
                        (click)="
                          action.ActionId > 0
                            ? showActions(action.ActionId, action.ProcessId)
                            : $event.preventDefault()
                        "
                        ><i class="fa fa-hand-o-up"></i>
                        {{ "OBSERVATION.ACTION" | translate }}
                        <ng-container *ngIf="action.ActionId > 0">{{
                          action.ActionId
                        }}</ng-container>
                      </a>
                      <span class="action-details-status">
                        <label style="margin: 0"
                          >Status :<span style="margin-left: 5px">{{
                            action.Status
                          }}</span></label
                        >
                      </span>
                    </th>
                  </tr>
                  <tr
                    *ngIf="
                      permissions.OBS_Admin ||
                      permissions.OBS_Admin_Unit ||
                      (!permissions.OBS_Admin &&
                        !permissions.OBS_Admin_Unit &&
                        !independentPermissions.SUPER_Admin &&
                        action.Status !== 'Deleted')
                    "
                  >
                    <td colspan="7">
                      <ara-textarea
                        [sourceText]="action.Action"
                        [maxLength]="1000"
                        rows="4"
                        cols="30"
                        [disabled]="
                          (!permissions.OBS_Admin &&
                            !permissions.OBS_Admin_Unit &&
                            action.ActionId > 0) ||
                          action?.Status === 'Deleted' ||
                          action?.Status === 'Closed' ||
                          action?.Status === 'Cancelled' ||
                          observationData.Status === 'Cancelled'
                        "
                        (output)="getRemarks($event, 'Action', i)"
                      ></ara-textarea>
                      <div
                        *ngIf="!action.Action && action.ShowActionErrorMessage"
                      >
                        <span class="error-msg-colour"
                          >Provide action details</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr
                    *ngIf="
                      permissions.OBS_Admin ||
                      permissions.OBS_Admin_Unit ||
                      (!permissions.OBS_Admin &&
                        !permissions.OBS_Admin_Unit &&
                        !independentPermissions.SUPER_Admin &&
                        action.Status !== 'Deleted')
                    "
                  >
                    <td style="width: 200px">
                      <strong>{{
                        "OBSERVATION.ACTION_OWNER" | translate
                      }}</strong>
                      <br />
                      <p-autoComplete
                        [(ngModel)]="action.ActionOwner"
                        [suggestions]="userResults"
                        (completeMethod)="getUsersOnSearch($event)"
                        (onSelect)="selectActionOwner($event, i)"
                        (change)="selectActionOwner($event, i)"
                        placeholder="Action Owner"
                        appendTo="body"
                        [disabled]="
                          (!permissions.OBS_Admin &&
                            !permissions.OBS_Admin_Unit &&
                            action.ActionId > 0) ||
                          action?.Status === 'Deleted' ||
                          action?.Status === 'Closed' ||
                          action?.Status === 'Cancelled' ||
                          observationData.Status === 'Cancelled'
                        "
                        field="FullName"
                        [minLength]="1"
                        [style]="{ width: '100%' }"
                        [inputStyle]="{ width: '100%' }"
                        [forceSelection]="true"
                      >
                        <ng-template let-actionowner pTemplate="item">
                          <span [title]="actionowner.Email">{{
                            actionowner.FullName
                          }}</span>
                        </ng-template>
                      </p-autoComplete>
                      <div *ngIf="action.ShowActionOwnerErrorMessage">
                        <span class="error-msg-colour"
                          >Kindly select action owner</span
                        >
                      </div>
                    </td>
                    <td style="width: 200px">
                      <strong>{{
                        "OBSERVATION.ACTION_PARTY" | translate
                      }}</strong>
                      <br />
                      <p-autoComplete
                        [(ngModel)]="action.selectedActionParty"
                        [suggestions]="userResults"
                        (completeMethod)="getUsersOnSearch($event)"
                        (onSelect)="selectActionParty($event, i)"
                        [disabled]="
                          (!permissions.OBS_Admin &&
                            !permissions.OBS_Admin_Unit &&
                            action.ActionId > 0) ||
                          action?.Status === 'Deleted' ||
                          action?.Status === 'Closed' ||
                          action?.Status === 'Cancelled' ||
                          observationData.Status === 'Cancelled'
                        "
                        (change)="selectActionParty($event, i)"
                        placeholder="Action Party"
                        field="FullName"
                        [minLength]="1"
                        [style]="{ width: '100%' }"
                        appendTo="body"
                        [inputStyle]="{ width: '100%' }"
                        [forceSelection]="true"
                      >
                        <ng-template let-actionparty pTemplate="item">
                          <span [title]="actionparty.Email">{{
                            actionparty.FullName
                          }}</span>
                        </ng-template>
                      </p-autoComplete>
                      <div
                        class="margin-top-10"
                        *ngIf="action.ShowActionPartyErrorMessage"
                      >
                        <span class="error-msg-colour"
                          >Kindly select action party</span
                        >
                      </div>
                    </td>
                    <td style="width: 200px">
                      <strong>{{
                        "OBSERVATION.ACTION_VERIFIER" | translate
                      }}</strong>
                      <br />
                      <p-autoComplete
                        [(ngModel)]="action.selectedActionVerifier"
                        [suggestions]="userResults"
                        (completeMethod)="getUsersOnSearch($event)"
                        (onSelect)="selectActionVerifier($event, i)"
                        (change)="selectActionVerifier($event, i)"
                        placeholder="Action Verifier"
                        field="FullName"
                        [disabled]="
                          (!permissions.OBS_Admin &&
                            !permissions.OBS_Admin_Unit &&
                            action.ActionId > 0) ||
                          action?.Status === 'Deleted' ||
                          action?.Status === 'Closed' ||
                          action?.Status === 'Cancelled' ||
                          observationData.Status === 'Cancelled'
                        "
                        [minLength]="1"
                        [style]="{ width: '100%' }"
                        appendTo="body"
                        [inputStyle]="{ width: '100%' }"
                        [forceSelection]="true"
                      >
                        <ng-template let-actionVerifier pTemplate="item">
                          <span [title]="actionVerifier.Email">{{
                            actionVerifier.FullName
                          }}</span>
                        </ng-template>
                      </p-autoComplete>
                    </td>
                    <td style="width: 90px">
                      <strong>{{ "OBSERVATION.PRIORITY" | translate }}</strong>
                      <br />
                      <select
                        class="form-control"
                        id="sel1"
                        [(ngModel)]="action.Priority"
                        [disabled]="
                          (!permissions.OBS_Admin &&
                            !permissions.OBS_Admin_Unit &&
                            action.ActionId > 0) ||
                          action?.Status === 'Deleted' ||
                          action?.Status === 'Closed' ||
                          action?.Status === 'Cancelled' ||
                          observationData.Status === 'Cancelled'
                        "
                      >
                        <option [ngValue]="0">Select</option>
                        <option [ngValue]="3">High</option>
                        <option [ngValue]="2">Medium</option>
                        <option [ngValue]="1">Low</option>
                      </select>
                      <div
                        *ngIf="
                          !action.Priority && action.ShowPriorityErrorMessage
                        "
                      >
                        <span class="error-msg-colour"
                          >Kindly select priority</span
                        >
                      </div>
                    </td>
                    <td style="width: 100px">
                      <strong>{{
                        "OBSERVATION.TARGET_DATE" | translate
                      }}</strong>
                      <br />
                      <div class="p-calendar">
                        <p-calendar
                          [showIcon]="true"
                          dateFormat="dd/mm/yy"
                          [showTime]="true"
                          [(ngModel)]="action.TargetDate"
                          readonlyInput="true"
                          required
                          #timeOfUse="ngModel"
                          [disabled]="
                            (!permissions.OBS_Admin &&
                              !permissions.OBS_Admin_Unit &&
                              action.ActionId > 0) ||
                            action?.Status === 'Deleted' ||
                            action?.Status === 'Closed' ||
                            action?.Status === 'Cancelled' ||
                            observationData.Status === 'Cancelled'
                          "
                          appendTo="body"
                          hideOnDateTimeSelect="true"
                          monthNavigator="true"
                          yearNavigator="true"
                          yearRange="1950:2100"
                        >
                        </p-calendar>
                        <div *ngIf="!action.TargetDate">
                          <span class="error-msg-colour"
                            >Kindly select target date</span
                          >
                        </div>
                      </div>
                    </td>
                    <td style="width: 350px">
                      <ara-file-upload
                        [accept]="accept"
                        [multiple]="multiple"
                        [disabled]="
                          (!permissions.OBS_Admin &&
                            !permissions.OBS_Admin_Unit &&
                            action.ActionId > 0) ||
                          action?.Status === 'Deleted' ||
                          action?.Status === 'Closed' ||
                          action?.Status === 'Cancelled' ||
                          observationData.Status === 'Cancelled'
                        "
                        [(inputFiles)]="action.Files"
                        (onInputFilesUpdatedData)="
                          onInputFilesUpdated($event, 'ObservationAction', i)
                        "
                      >
                      </ara-file-upload>
                      <ara-files-previewer
                        [files]="action.FilesPreview"
                      ></ara-files-previewer>
                    </td>
                    <td
                      style="width: 50px"
                      *ngIf="
                        (permissions.OBS_Admin || permissions.OBS_Admin_Unit) &&
                        (action.Status === 'Open' ||
                          action.Status === 'Reopen' ||
                          action.Status === 'Accepted' ||
                          action.Status === 'Closed')
                      "
                    >
                      <a
                        *ngIf="action.ActionId === 0"
                        (click)="removeActionFromActionList(i)"
                        (click)="removeActionFromActionList(i)"
                      >
                        <i class="fa fa-trash"></i>
                      </a>
                      <a
                        (click)="cancelAssigned(action.ActionId, i)"
                        *ngIf="
                          (permissions.OBS_Admin ||
                            permissions.OBS_Admin_Unit) &&
                          action.ActionId > 0
                        "
                      >
                        <i
                          class="fa fa-times"
                          data-toggle="tooltip"
                          pTooltip="Cancel Action"
                          tooltipPosition="top"
                        ></i>
                      </a>
                      <a
                        (click)="deleteAssigned(action.ActionId, i)"
                        *ngIf="
                          (permissions.OBS_Admin ||
                            permissions.OBS_Admin_Unit) &&
                          action.ActionId > 0
                        "
                      >
                        <i
                          class="fa fa-trash"
                          data-toggle="tooltip"
                          pTooltip="Delete Action"
                          tooltipPosition="top"
                        ></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- End table-responsive -->
            </div>
            <a
              *ngIf="permissions.OBS_Admin || permissions.OBS_Admin_Unit"
              (click)="addAction()"
              class="pull-right margin-top-10"
            >
              <i
                class="fa fa-plus"
                aria-hidden="true"
                style="padding-right: 6px"
              ></i
              >Add Action
            </a>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="breaker"></div>
        <footer>
          <button
            [routerLink]="['../../observation-card-overview']"
            role="button"
            class="btn btn-primary primary-btn button-back button-float-left"
            *ngIf="Button.showBackToDashboardButton"
          >
            <i class="fa fa-reply"></i>Back to Overview
          </button>
          <button
            type="button"
            *ngIf="observationId !== 0 && observationId"
            (click)="ReportshowDialog()"
            class="btn btn-primary primary-btn button-report-log button-float-left"
          >
            Report Log
          </button>
          <button
            type="button"
            class="btn btn-warning"
            (click)="confirmResetForm()"
            *ngIf="Button.showResetButton"
          >
            <i class="fa fa-refresh"></i>RESET
          </button>
          <button
            type="button"
            class="btn btn-primary primary-btn button-draft"
            (click)="saveAsDraft()"
            *ngIf="
              (observationId === 0 || observationData.Status === 'Draft') &&
              navigator.onLine
            "
          >
            <i class="fa fa-envelope"></i>Save As Draft
          </button>
          <button
            *ngIf="
              observationId !== 0 &&
              observationId &&
              observationData.Status !== 'Draft' &&
              navigator.onLine
            "
            role="button"
            class="btn btn-primary primary-btn button-pdf"
            (click)="downloadPDF()"
          >
            <i class="fa fa-file-pdf-o"></i>DOWNLOAD PDF
          </button>
          <button
            type="button"
            class="btn btn-success button-submit"
            (click)="checkValidation()"
            *ngIf="Button.showSubmitButton"
          >
            <i class="fa fa-share-square"></i>SUBMIT
          </button>

          <button
            [title]="isInactiveLocation ? 'This location is inactive' : ''"
            type="button"
            class="btn btn-success button-update"
            (click)="checkValidation(true)"
            *ngIf="
              (!disableObservation &&
                observationId > 0 &&
                observationData.Status !== 'Draft') ||
              (observationId > 0 &&
                (permissions.OBS_Admin || permissions.OBS_Admin_Unit) &&
                observationData.Status !== 'Draft') ||
              (loggedInUserJSON.UserId == observationData.RaisedFor &&
                observationId > 0 &&
                !disableObservation &&
                observationData.Status !== 'Draft')
            "
            [disabled]="!editEnabled || !isUpdateAllowed || isInactiveLocation"
          >
            <i class="fa fa-share-square"></i>UPDATE
          </button>
          <button
            type="button"
            class="btn btn-success button-submit"
            (click)="checkValidation(true)"
            *ngIf="
              ((!disableObservation &&
                observationId > 0 &&
                observationData.Status === 'Draft') ||
                (observationId > 0 &&
                  (permissions.OBS_Admin || permissions.OBS_Admin_Unit) &&
                  observationData.Status === 'Draft') ||
                (observationId > 0 && observationData.Status === 'Draft')) &&
              navigator.onLine
            "
          >
            <i class="fa fa-share-square"></i>Submit
          </button>
          <button
            role="button"
            class="btn btn-primary primary-btn button-acknowledge"
            (click)="acknowledgeObservationRequest()"
            *ngIf="
              (permissions.OBS_Admin || permissions.OBS_Admin_Unit) &&
              observationData.Status === 'New' &&
              navigator.onLine
            "
            [disabled]="!editEnabled"
          >
            <i class="fa fa-share-square"></i>acknowledge
          </button>
        </footer>
      </div>
    </div>
    <ara-alerts
      [alertType]="alertType"
      [successDetails]="successDetails"
      [errorDetails]="errorDetails"
      (okClicked)="onOkClicked()"
      [confirmMessage]="confirmMessage"
      (yesClicked)="onYesClickedForConfirmation()"
      (noClicked)="onNoClickedForConfirmation()"
    ></ara-alerts>
    <div class="clearfix"></div>
    <span *ngIf="ReportclosePopup">
      <p-dialog
        header="Report History"
        [(visible)]="ReportclosePopup"
        (onHide)="ReportclosePopUp()"
        [modal]="true"
      >
        <ara-report-log
          [ReportUserId]="ReportUserId"
          [ReportModule]="ReportModule"
          [ReportRecordId]="ReportRecordId"
        >
        </ara-report-log>
      </p-dialog>
    </span>
  </div>
</div>
<div class="clearfix"></div>
